import React from "react"
import { MaterialSymbol } from "./MaterialSymbol"

export const AdvantageIcon = () => <MaterialSymbol>keyboard_double_arrow_up</MaterialSymbol>;
export const DisadvantageIcon = () => <MaterialSymbol>keyboard_double_arrow_down</MaterialSymbol>;
export const OnDCPassIcon = () => <MaterialSymbol>keyboard_double_arrow_right</MaterialSymbol>;